export default function () {
  return {
    placesFields: [
      {
        key: 'name',
        label: 'Destino'
      },
      {
        key: 'total',
        label: 'Quantidade'
      }
    ],
    categoriesFields: [
      {
        key: 'name',
        label: 'Categoria'
      },
      {
        key: 'total',
        label: 'Quantidade'
      }
    ],
    agenciesFields: [
      {
        key: 'name',
        label: 'Agência'
      },
      {
        key: 'total',
        label: 'Quantidade'
      }
    ],
    monthsFields: [
      {
        key: 'name',
        label: 'Mês'
      },
      {
        key: 'total',
        label: 'Quantidade'
      },
      {
        key: 'amount',
        label: 'Valor total'
      },
      {
        key: 'passengers',
        label: 'Passageiros'
      }
    ],
    places: [],
    categories: [],
    agencies: [],
    months: [],
    filter: 'this_year'
  }
}
